import { render, staticRenderFns } from "./MarksEntry.vue?vue&type=template&id=108394a2&"
import script from "./MarksEntry.vue?vue&type=script&lang=js&"
export * from "./MarksEntry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports